import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  d: "M19.995 7.85L20 8v32a2 2 0 01-3.995.15L16 40V12.161l-6.75 5.4a2 2 0 01-2.623-3.015l.124-.108 10-8c1.27-1.016 3.132-.17 3.244 1.412zm9.292 9.619l.127.117L33 21.17l3.586-3.585a2 2 0 012.828 2.828L35.828 24l3.586 3.587a2 2 0 01-2.701 2.945l-.127-.117L33 26.828l-3.586 3.586a2 2 0 01-2.828-2.828l3.585-3.587-3.585-3.585a2 2 0 012.701-2.945z",
  fill: "#262626"
}));

var SvgCleanOnceXLarge = function SvgCleanOnceXLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgCleanOnceXLarge;